import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../../Services/Api/ApiServices";

export const ChangeReportStatus = createAsyncThunk(
  "ChangeReportStatus/ChangeReportStatus",
  async (param, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/Report/ChangeReportStatus",
        param
      );

      // Extract data from the response object
      const data = response.data; // Assuming response has a "data" field

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const GetReportInfo = createAsyncThunk(
  "GetReportInfo/GetReportInfo",
  async (param, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post("api/Report/GetReportInfo", param);

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const GetSpecificRowReport = createAsyncThunk(
  "GetReportInfo/GetSpecificRowReport",
  async (param, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post("api/Report/GetSpecificRowReport", param);

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const EditReportProjectObjective = createAsyncThunk(
  "GetReportInfo/EditReportProjectObjective",
  async (param, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post("api/Report/EditReportProjectObjective", param);

      // Extract data from the response object
      const data = response.data; // Assuming response has a "data" field

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const GetSpecificRowReportByApplicationInfo = createAsyncThunk(
  "GetReportInfo/GetSpecificRowReportByApplicationInfo",
  async (param, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post("/api/Report/GetSpecificRowReportByApplicationInfo", param);

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const ReportStatus = createSlice({
  name: "ReportStatus",
  initialState: {
    ReportStatus: {},
    loadingReportStatus: false,
    errorReportStatus: null,
    ////////////////////////////////////
    ReportInfo: {},
    loadingReportInfo: false,
    errorReportInfo: null,
    ////////////////////////////////////
    ReportRow: {},
    loadingReportRow: false,
    errorReportRow: null,
    ////////////////////////////////////
    EditReportProjectObjective: {},
    loadingEditReportProjectObjective: false,
    errorEditReportProjectObjective: null,
    ////////////////////////////////////
    ReportRowByAppId: {},
    loadingReportRowByAppId: false,
    errorReportRowByAppId: null,
  },
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(ChangeReportStatus.pending, (state, action) => {
        state.loadingReportStatus = true;
        state.ReportStatus = action.payload;
        state.errorReportStatus = null;
      })
      .addCase(ChangeReportStatus.fulfilled, (state, action) => {
        state.loadingReportStatus = false;
        state.ReportStatus = action.payload; // Assuming payload has the desired data
      })
      .addCase(ChangeReportStatus.rejected, (state, action) => {
        state.loadingReportStatus = false;
        state.errorReportStatus = action.payload;
      })
      ///////////////////////////////////////////////////////
      builder
      .addCase(GetReportInfo.pending, (state, action) => {
        state.loadingReportInfo = true;
        state.ReportInfo = action.payload;
        state.errorReportStatus = null;
      })
      .addCase(GetReportInfo.fulfilled, (state, action) => {
        state.loadingReportInfo = false;
        state.ReportInfo = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetReportInfo.rejected, (state, action) => {
        state.loadingReportInfo = false;
        state.errorReportStatus = action.payload;
      });
      /////////////////////////////////////////////////////
      builder
      .addCase(GetSpecificRowReport.pending, (state, action) => {
        state.loadingReportRow = true;
        state.ReportRow = action.payload;
        state.errorReportRow = null;
      })
      .addCase(GetSpecificRowReport.fulfilled, (state, action) => {
        state.loadingReportRow = false;
        state.ReportRow = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetSpecificRowReport.rejected, (state, action) => {
        state.loadingReportRow = false;
        state.errorReportRow = action.payload;
      });
      /////////////////////////////////////////////////////
      builder
      .addCase(EditReportProjectObjective.pending, (state, action) => {
        state.loadingEditReportProjectObjective = true;
        state.EditReportProjectObjective = action.payload;
        state.errorEditReportProjectObjective = null;
      })
      .addCase(EditReportProjectObjective.fulfilled, (state, action) => {
        state.loadingEditReportProjectObjective = false;
        state.EditReportProjectObjective = action.payload; // Assuming payload has the desired data
      })
      .addCase(EditReportProjectObjective.rejected, (state, action) => {
        state.loadingEditReportProjectObjective = false;
        state.errorEditReportProjectObjective = action.payload;
      });
      /////////////////////////////////////////////////////
      builder
      .addCase(GetSpecificRowReportByApplicationInfo.pending, (state, action) => {
        state.loadingReportRowByAppId = true;
        state.ReportRowByAppId = action.payload;
        state.errorReportRowByAppId = null;
      })
      .addCase(GetSpecificRowReportByApplicationInfo.fulfilled, (state, action) => {
        state.loadingReportRowByAppId = false;
        state.ReportRowByAppId = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetSpecificRowReportByApplicationInfo.rejected, (state, action) => {
        state.loadingReportRowByAppId = false;
        state.errorReportRowByAppId = action.payload;
      });
  },
});

export default ReportStatus.reducer;
